const Events = {
  // * ASwap nav
  NAV_REQUEST_URL: "nav_open_url",
  NAV_REQUEST_LOAD: "nav_request_load",
  NAV_REQUEST_LOADED: "nav_request_loaded",
  
  // * animation related events: hide / hidden / show / shown
  NAV_VIEW_HIDE: "nav_veiw_hide",
  NAV_VIEW_HIDDEN: "nav_veiw_hidden",  
  NAV_SWAP_START: "nav_swap_start",
  NAV_SWAP_COMPLETE: "nav_swap_complete",
  NAV_VIEW_SHOW: "nav_view_show", 
  NAV_VIEW_SHOWN: "nav_view_shown" 
  
}

export default Events;